import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6fe2544d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "create-entity-container" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "create-entity-background" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_FriedH2 = _resolveComponent("FriedH2");
    const _component_FriedLink = _resolveComponent("FriedLink");
    const _component_i18n_t = _resolveComponent("i18n-t");
    const _component_FriedMessage = _resolveComponent("FriedMessage");
    const _component_CreateEntityForm = _resolveComponent("CreateEntityForm");
    const _component_FriedButton = _resolveComponent("FriedButton");
    const _component_LoginSignupContainer = _resolveComponent("LoginSignupContainer");
    const _component_FriedModalHeader = _resolveComponent("FriedModalHeader");
    const _component_FriedModalButtonsFooter = _resolveComponent("FriedModalButtonsFooter");
    const _component_FriedModal = _resolveComponent("FriedModal");
    return (_ctx.isSignup)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "appear"
        }, {
            default: _withCtx(() => [
                _createVNode(_component_LoginSignupContainer, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createVNode(_component_FriedParagraph, { class: "branding" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('create-account')), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_FriedH2, { class: "branding create-entity-title" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('create-company-profile')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            (_ctx.error)
                                ? (_openBlock(), _createBlock(_component_FriedMessage, {
                                    key: 0,
                                    class: "error",
                                    title: _ctx.$t(_ctx.error.title),
                                    type: _ctx.MessageType.Error
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_i18n_t, {
                                            keypath: _ctx.error.description
                                        }, {
                                            contactSupportLink: _withCtx(() => [
                                                _createVNode(_component_FriedLink, {
                                                    normal: true,
                                                    href: "http://help.getaccept.com/",
                                                    target: "_blank"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('contact-support')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["keypath"])
                                    ]),
                                    _: 1
                                }, 8, ["title", "type"]))
                                : _createCommentVNode("", true),
                            (_ctx.initialFormData)
                                ? (_openBlock(), _createBlock(_component_CreateEntityForm, {
                                    key: 1,
                                    id: "createEntityForm",
                                    "initial-form-data": _ctx.initialFormData,
                                    onSubmit: _ctx.handleSubmit
                                }, null, 8, ["initial-form-data", "onSubmit"]))
                                : _createCommentVNode("", true),
                            _createVNode(_component_FriedButton, {
                                type: "submit",
                                form: "createEntityForm",
                                class: "create-entity-button",
                                "data-external": "create-entity-submit-button",
                                loading: _ctx.loading
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
                                ]),
                                _: 1
                            }, 8, ["loading"])
                        ])
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_FriedModal, {
                class: "create-entity-modal",
                onClose: _ctx.handleCancel
            }, {
                header: _withCtx(() => [
                    _createVNode(_component_FriedModalHeader, {
                        header: _ctx.$t('create-company-profile'),
                        description: _ctx.$t('enter-the-name-of-your-company-or-organization')
                    }, null, 8, ["header", "description"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_component_FriedModalButtonsFooter, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_FriedButton, {
                                type: "button",
                                "button-type": _ctx.ButtonType.Secondary,
                                "data-external": "create-entity-cancel-button",
                                onClick: _ctx.handleCancel
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                ]),
                                _: 1
                            }, 8, ["button-type", "onClick"]),
                            _createVNode(_component_FriedButton, {
                                type: "submit",
                                form: "createEntityForm",
                                "data-external": "create-entity-submit-button",
                                loading: _ctx.loading
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
                                ]),
                                _: 1
                            }, 8, ["loading"])
                        ]),
                        _: 1
                    })
                ]),
                default: _withCtx(() => [
                    (_ctx.error)
                        ? (_openBlock(), _createBlock(_component_FriedMessage, {
                            key: 0,
                            class: "error",
                            title: _ctx.$t(_ctx.error.title),
                            type: _ctx.MessageType.Error
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_i18n_t, {
                                    keypath: _ctx.error.description
                                }, {
                                    contactSupportLink: _withCtx(() => [
                                        _createVNode(_component_FriedLink, {
                                            normal: true,
                                            href: "http://help.getaccept.com/",
                                            target: "_blank"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('contact-support')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["keypath"])
                            ]),
                            _: 1
                        }, 8, ["title", "type"]))
                        : _createCommentVNode("", true),
                    (_ctx.initialFormData)
                        ? (_openBlock(), _createBlock(_component_CreateEntityForm, {
                            key: 1,
                            id: "createEntityForm",
                            "initial-form-data": _ctx.initialFormData,
                            onSubmit: _ctx.handleSubmit
                        }, null, 8, ["initial-form-data", "onSubmit"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["onClose"])
        ]));
}
